export default __webpack_public_path__ + "static/media/Muli-SemiBold.47cdb230.ttf";